/**
 * @flow
 * @relayHash 2f8cc7aa8484528760f9c91f2a52273f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type markAttendedInput = {|
  clientMutationId?: ?string,
  eventId: string,
  id: string,
|};
export type markAttendedMutationVariables = {|
  input: markAttendedInput
|};
export type markAttendedMutationResponse = {|
  +markAttended: ?{|
    +attendee: ?{|
      +id: string,
      +fullName: string,
      +email: string,
      +phone: string,
      +additionalGuests: number,
      +status: ?string,
      +crmUrl: ?string,
      +isResident: ?boolean,
      +attended: ?boolean,
      +rsvpCancelReason: ?string,
    |}
  |}
|};
export type markAttendedMutation = {|
  variables: markAttendedMutationVariables,
  response: markAttendedMutationResponse,
|};
*/


/*
mutation markAttendedMutation(
  $input: markAttendedInput!
) {
  markAttended(input: $input) {
    attendee {
      id
      fullName
      email
      phone
      additionalGuests
      status
      crmUrl
      isResident
      attended
      rsvpCancelReason
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "markAttendedInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "markAttended",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "markAttendedPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "attendee",
        "storageKey": null,
        "args": null,
        "concreteType": "Attendee",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fullName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "additionalGuests",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "crmUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isResident",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "attended",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rsvpCancelReason",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "markAttendedMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "markAttendedMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "markAttendedMutation",
    "id": null,
    "text": "mutation markAttendedMutation(\n  $input: markAttendedInput!\n) {\n  markAttended(input: $input) {\n    attendee {\n      id\n      fullName\n      email\n      phone\n      additionalGuests\n      status\n      crmUrl\n      isResident\n      attended\n      rsvpCancelReason\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1b2394ee19b7f204b0ddf73dd88e07b0';
module.exports = node;
